import request from "../shared/http";

class ApiService {
  static async getHealth() {
    const { data } = await request.get("/health");
    return data;
  }

  static async signin(username, password, type = "user") {
    const { data } = await request.post("/signin", { username, password, type });
    return data;
  }

  static async signup(payload) {
    const { data } = await request.post("/signup", payload);
    return data;
  }

  static async signout() {
    const { data } = await request.post("/signout");
    return data;
  }

  static async getAccountMe() {
    const { data } = await request.get("/accounts/@me");
    return data;
  }
}

export default ApiService;
